
import { useNavigate } from 'react-router-dom';
import { Pagination, Paper, Stack, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField } from '@mui/material';
import { envVariables, formatoHorasDetallado, separadorMillares } from '../../../../helpers';
import { AlertScreen } from '../../components/AlertScreen';
import { usePlanillassStore } from '../../../../store';


import dayjs from 'dayjs';
const paginado = Number( envVariables.REACT_APP_PAGINADO);



export const TablaListadoPlanillas = ({ data, chagePage, page }) => {


    const navigate = useNavigate();
    const { totalPlanillas } = usePlanillassStore();


    const hanldeOpciones = (id)  => {
        navigate(`/admin/opcion/${id}/planilla`)
    }


    return (
        <>
        {(data.length > 0) 
        ?   <Paper sx={{width:'100%', maxWidth:{xs:450, sm:'100%', md:'100%'}, overflowX:'auto'}}>
                <TableContainer >
                    <Table sx={{minWidth:700, overflowX:'auto'}}>
                        <TableHead>
                            <TableRow>
                                <TableCell sx={{width:'5%'}}>#</TableCell>
                                <TableCell sx={{width:'20%'}}>FECHA</TableCell>
                                <TableCell sx={{width:'30%'}}>CLIENTE</TableCell>
                                <TableCell sx={{width:'10%'}}>CANTIDAD</TableCell>
                                <TableCell sx={{width:'20%'}}>DURACIÓN</TableCell>
                                <TableCell sx={{width:'20%'}}>TOTAL</TableCell>
                            </TableRow>
                        </TableHead>

                        <TableBody>
                            {data.map((item) => (
                            <TableRow sx={{cursor:'pointer'}} key={item.id} onClick={ () => hanldeOpciones(item.id) }> 
                                <TableCell>{ item.numero }</TableCell>
                                <TableCell>{ dayjs(item.fecha).format('DD/MM/YYYY') }</TableCell>
                                <TableCell>{ item.cliente.nombre }</TableCell>
                                <TableCell>{ item.cantidad }</TableCell>
                                <TableCell>{ formatoHorasDetallado(item.horaInicio, item.horaFinal) }</TableCell>
                                <TableCell>{ `$${separadorMillares(item.valorTotal)}` }</TableCell>
                            </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                    
                    <Stack sx={{ py:2, display:'flex', justifyContent:'center', alignItems:'center' }}>
                        <Pagination count={Math.ceil(totalPlanillas / paginado)} disabled={Math.ceil(totalPlanillas / paginado) === 1}
                            variant="outlined" page={page + 1} color="primary" 
                            onChange={ (_, newValor) => chagePage(newValor) } 
                        />
                    </Stack>
                </TableContainer>
            </Paper>

        :   <AlertScreen title="No hay planillas creadas por el momento..."/>
        }
        </>
    )
}
